import React from 'react'
import './intro.css'
const Intro = () => {
  return (
    <div>
      <div class="container">
  <div class="logo_holder">
    <div class="logo_holder__rotate">
      <svg class="logo_holder__right" enable-background="new 0 0 94.852 96.499" height="96.499px" id="Layer_1" space="preserve" version="1.1" viewBox="0 0 94.852 96.499" width="94.852px" x="0px" y="0px">
        <polygon fill="#FFFFFF" points="48.689,0 0,91.806 8.844,96.499 52.842,13.537 81.316,28.635 62.492,63.968 73.908,63.968   94.852,24.482 "></polygon>
      </svg>
      <svg class="logo_holder__left" enable-background="new 0 0 94.852 96.499" height="96.499px" id="Layer_1" space="preserve" version="1.1" viewBox="0 0 94.852 96.499" width="94.852px" x="0px" y="0px">
        <polygon fill="#FFFFFF" points="48.689,0 0,91.806 8.844,96.499 52.842,13.537 81.316,28.635 62.492,63.968 73.908,63.968   94.852,24.482 "></polygon>
      </svg>
    </div>
    <svg class="logo_holder__text" enable-background="new 0 0 331 129.667" height="129.667px" id="Layer_1" space="preserve" version="1.1" viewBox="0 0 331 129.667" width="331px" x="0px" y="0px">
      
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  {/* <path d="M15.004,47.612c1.225,0.585,2.758,0.919,4.597,0.919c6.436,0,8.682-3.769,8.682-9.46V2.948h13.279v35.704  c0,14.149-9.295,20.347-21.757,20.347c-3.576,0-7.047-0.504-10.01-1.594L15.004,47.612z" fill="#FFFFFF"></path> */}
  <text x="-75" y="80" fill="#FFFFFF" style={{fontSize:"70px"}}>Aryan</text>
</svg>
    </svg>
    
   <h2>Web/UI Designer  Front End Developer</h2>
    <nav>
      <a href="https://aryan-portfolio-test.netlify.app/">Portfolio</a>
      <a href="https://www.linkedin.com/in/aryan-agrahari-a498b11a8/">LinkedIn</a>
      <a href="https://www.instagram.com/aryan_agrahari_7/">Instagram</a>
      <a href="https://github.com/AryanAgrahari07">GitHub</a>
    </nav>
  </div>
</div>
    </div>
  )
}

export default Intro
